import News from '../routes/news'

export default News
